'use strict';

import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.css';

import angular from 'angular';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import 'angular-socket-io';
import 'angular-xeditable';
import 'checklist-model/checklist-model';
import ngDialogs from 'angular-dialog-service';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import ngValidationMatch from 'angular-validation-match';
import ngFileUpload from 'ng-file-upload';

import 'textangular/dist/textAngular-sanitize.min';
import 'textangular/dist/textAngular.min';
import 'textangular/dist/textAngular.css';

import 'expose-loader?moment!moment-timezone';
import 'angular-moment';

import {
  routeConfig,
  schemaFormCustomFields,
  addCustomFieldsCache,
  decorateTextAngular,
  schemaFormSingleFileUpload,
  addSingleFileUploadCache,
  schemaFormPlaceholderTranslate
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import mongooseError from '../components/mongoose-error/mongoose-error.directive';
import main from './main/main.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';

import StorageService from '../components/storage/storage.service';
import HomeComponent from './home/home.component';

import newlineToHtmlFilter from '../components/newline-to-html/newlineToHtml.filter';

import datatables from 'angular-datatables';
import 'angular-datatables/dist/plugins/buttons/angular-datatables.buttons';
import 'angular-datatables/dist/plugins/bootstrap/datatables.bootstrap.min.css';

import 'datatables.net-responsive/js/dataTables.responsive';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';

import 'datatables.net-buttons';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';

import 'datatables.net-rowgroup/js/dataTables.rowGroup.min';

import 'datatables.net-buttons-dt/css/buttons.dataTables.css';

import 'jquery-ui/ui/widgets/sortable';
import 'angular-ui-sortable/dist/sortable';

import 'ng-image-gallery/dist/ng-image-gallery';
import 'ng-image-gallery/dist/ng-image-gallery.css';

import 'fullcalendar/dist/fullcalendar.min';
import 'fullcalendar/dist/fullcalendar.min.css';
import 'angular-ui-calendar/src/calendar';

import 'angular-bootstrap-datetimepicker';
import 'angular-bootstrap-datetimepicker/src/css/datetimepicker.css';

import SettingsService from '../components/settings/settings.service';
import SettingsListComponent from './admin/settings-list/settings-list.component';
import SettingsEditComponent from './admin/settings-edit/settings-edit.component';

import DynamicPageComponent from './dynamic-page/dynamic-page.component';
import DynamicPageService from '../components/dynamic-page/dynamic-page.service';

import jsonView from '../components/json-view/json-view.component';
import jsonViewDirective from '../components/json-view/json-view.directive';

import DataTableLoadingPlaceholderComponent from '../components/datatable-loading-placeholder/datatable-loading-placeholder.component';

import startFromFilter from '../components/start-from/startFrom.filter';

import FeedbackFormularComponent from '../components/feedback-formular/feedback-formular.component';

import SearchResultComponent from './search/result/search-result.component';

import 'bootstrap/js/carousel';

import './app.scss';

import 'angular-ui-codemirror/src/ui-codemirror';

import 'angular-timeline/dist/angular-timeline';
import 'angular-timeline/dist/angular-timeline.css';
import 'angular-timeline/dist/angular-timeline-bootstrap.css';

import HistoryService from '../components/history/history.service';

import ProfileComponent from './user/profile/profile.component';
import ProfilePictureUploadComponent from './user/profile-picture-upload/profile-picture-upload.component';

import 'chart.js/src/chart';
import 'angular-chart.js/angular-chart';

import 'angular-prompt/dist/angular-prompt';

import CommunityService from '../components/community/community.service';
import PropertyService from '../components/property/property.service';
import ContactService from '../components/contacts/contacts.service';

import ViolationsCodeListComponent from './violations/code-list/violations-code-list.component';
import ViolationsCodeEditComponent from './violations/code-edit/violations-code-edit.component';
import ViolationCodesService from '../components/violation-codes/violation-codes.service';

import ViolationTicketListComponent from './violations/ticket-list/violations-ticket-list.component';
import ViolationTicketEditComponent from './violations/ticket-edit/violations-ticket-edit.component';
import ViolationTicketShowComponent from './violations/ticket-show/violations-ticket-show.component';
import ViolationTicketsService from '../components/violation-tickets/violation-tickets.service';

import CommunityListComponent from './portfolio/community-list/community-list.component';
import CommunityEditComponent from './portfolio/community-edit/community-edit.component';
import CommunityShowComponent from './portfolio/community-show/community-show.component';

import ContactListComponent from './portfolio/contact-list/contact-list.component';
import ContactEditComponent from './portfolio/contact-edit/contact-edit.component';
import ContactShowComponent from './portfolio/contact-show/contact-show.component';

import PropertyListComponent from './portfolio/property-list/property-list.component';
import PropertyEditComponent from './portfolio/property-edit/property-edit.component';
import PropertyShowComponent from './portfolio/property-show/property-show.component';

import VendorListComponent from './portfolio/vendor-list/vendor-list.component';
import VendorEditComponent from './portfolio/vendor-edit/vendor-edit.component';
import VendorShowComponent from './portfolio/vendor-show/vendor-show.component';
import VendorService from '../components/vendors/vendors.service';

import WorkOrderCodeListComponent from './workorders/code-list/workorders-code-list.component';
import WorkOrderCodeEditComponent from './workorders/code-edit/workorders-code-edit.component';
import WorkOrderTicketListComponent from './workorders/ticket-list/workorder-ticket-list.component';
import WorkOrderTicketEditComponent from './workorders/ticket-edit/workorder-ticket-edit.component';
import WorkOrderTicketShowComponent from './workorders/ticket-show/workorder-ticket-show.component';
import WorkOrderService from '../components/workorder-codes/workorder-codes.service';
import WorkOrderTicketsService from '../components/workorder-tickets/workorder-tickets.service';

import ServiceRequestTicketListComponent from './servicerequests/ticket-list/servicerequest-ticket-list.component';
import ServiceRequestTicketEditComponent from './servicerequests/ticket-edit/servicerequest-ticket-edit.component';
import ServiceRequestTicketShowComponent from './servicerequests/ticket-show/servicerequest-ticket-show.component';
import ServiceRequestTicketsService from '../components/servicerequest-tickets/servicerequest-tickets.service';

import ClientSettingsComponent from './admin/client-edit/client-edit.component';

import TemplateService from '../components/templates/templates.service';
import TemplateListComponent from './template/template-list/template-list.component';
import TemplateEditComponent from './template/template-edit/template-edit.component';
import TemplateUploadComponent from './template/template-upload/template-upload.component';

import 'pickadate/lib/picker';
import 'pickadate/lib/themes/classic.css';
import 'pickadate/lib/themes/classic.date.css';
import 'pickadate/lib/themes/classic.time.css';

import 'expose-loader?tv4!tv4';
import 'angular-schema-form';
import 'angular-schema-form-bootstrap';

import 'angular-schema-form-bootstrap/bootstrap-decorator.min';
import 'angular-schema-form-datepicker/bootstrap-datepicker.min';

import 'angular-strap';
import 'angular-schema-form-dynamic-select';
import '../components/angular-schema-form-ui-codemirror/bootstrap-ui-codemirror.min';
import datetimepicker from 'angular-bootstrap-datetimepicker';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

import './schema-form.currency';
import './schema-form.picklist';
import './schema-form.datetimepicker';
import './schema-form.percent';

import AcctstComponent from './accounting/test/acctst.component';
import AccountingService from '../components/accounting/accounting.service';
import JournalEntriesComponent from './accounting/journal-entries/journal-entries.component';
import ChartOfAccountsComponent from './accounting/chart-of-accounts/chart-of-accounts.component';
import BalanceSheetComponent from './accounting/balance-sheet/balance-sheet.component';
import AddJournalEntryComponent from './accounting/add-journal-entry/add-journal-entry.component';

import AccountTreeComponent from '../components/account-tree/account-tree.component';
import AccountLookupComponent from '../components/account-lookup/account-lookup.component';
import PropertyLookupComponent from '../components/property-lookup/property-lookup.component';
import VendorLookupComponent from '../components/vendor-lookup/vendor-lookup.component';
import UserLookupComponent from '../components/user-lookup/user-lookup.component';
import CommunityLookupComponent from '../components/community-lookup/community-lookup.component';
import TemplateLookupComponent from '../components/template-lookup/template-lookup.component';
import ContactLookupComponent from '../components/contact-lookup/contact-lookup.component';

import 'angular-tree-control/angular-tree-control';
import 'angular-tree-control/context-menu';
import 'angular-tree-control/css/tree-control.css';
import 'angular-tree-control/css/tree-control-attribute.css';

import 'angular-ui-mask';

import ViewSelectionService from '../components/view-selection/view-selection.service';

import TaskService from '../components/tasks/tasks.service';
import TaskEditComponent from '../components/task-edit/task-edit.component';
import TaskShowComponent from '../components/task-show/task-show.component';
import 'angular-prompt/dist/angular-prompt';

import NTASectionComponent from '../components/nta-section/nta-section.component';

import AddressEditComponent from '../components/address-edit/address-edit.component';

import HeaderDropdownMenuComponent from '../components/header-dropdown-menu/header-dropdown-menu.component';
import InlineDropdownMenuComponent from '../components/inline-dropdown-menu/inline-dropdown-menu.component';
import UserCardComponent from '../components/user-card/user-card.component';

import calendar from './calendar';

import AssetUploadComponent from '../components/asset-upload/asset-upload.component';
import AttachmentListComponent from '../components/attachment-list/attachment-list.component';

import EditPropertyContactsComponent from '../components/edit-property-contacts/edit-property-contacts.component';
import AddPropertyContactComponent from '../components/add-property-contact/add-property-contact.component';

import USPhoneFilter from '../components/us-phone-filter/us-phone.filter';

import WorkOrderShowComponent from '../components/workorder-show/workorder-show.component';
import ViolationShowComponent from '../components/violation-show/violation-show.component';

import StateChangeFormComponent from '../components/state-change-form/state-change-form.component';

import RoleEditComponent from './admin/role-edit/role-edit.component';
import PermissionEditComponent from '../components/permission-edit/permission-edit.component';

import 'ng-sortable/dist/ng-sortable.min';
import 'ng-sortable/dist/ng-sortable.min.css';

import ProjectListComponent from './project/list/project-list.component';
import ProjectEditComponent from './project/edit/project-edit.component';
import ProjectBoardComponent from './project/board/project-board.component';

import ProjectItemEditComponent from '../components/project-item-edit/project-item-edit.component';

import ProjectService from '../components/project/project.service';
import ProjectItemService from '../components/project-item/project-item.service';
import 'ngstorage/ngStorage.min';

import RecentVisitsService from '../components/recent-visits/recent-visits.service';

import PinnedItemsService from '../components/pinned-items/pinned-items.service';
import 'angular-bootstrap-toggle/dist/angular-bootstrap-toggle.min';

import 'angular-bootstrap-toggle/dist/angular-bootstrap-toggle.min.css';
import '../components/angular-dashboard/malhar-angular-dashboard';

import '../components/angular-dashboard/malhar-angular-dashboard.css';
import DashboardComponent from './dashboard/dashboard.component';

import RolesConfigService from '../components/roles-config/roles-config.service';

import {permission, uiPermission} from 'angular-permission';

import ServiceRequestToWorkOrderComponent from '../components/service-request-to-workorder-form/service-request-to-workorder-form.component';

import TargetDateChangeComponent from '../components/target-date-change-form/target-date-change-form.component';

import IssuedToChangeComponent from '../components/issued-to-change-form/issued-to-change-form.component';
import ReportsComponent from './reports/reports.component';

import CustomEntityList from './custom/list/custom-list.component';
import CustomEntityEdit from './custom/edit/custom-edit.component';
import CustomEntityShow from './custom/show/custom-show.component';
import CustomEntityService from '../components/custom-entity/custom-entity.service';

import 'ng-idle/angular-idle.min';

import '../components/blurred-dialog/st-blurred-dialog';
import '../components/blurred-dialog/st-blurred-dialog.css';

import bindDynamicPage from '../components/bind-dynamic-page/bind-dynamic-page.directive';
import 'ng-tags-input/build/ng-tags-input.min';
import 'ng-tags-input/build/ng-tags-input.min.css';
import 'ng-tags-input/build/ng-tags-input.bootstrap.min.css';

import WebaccessListComponent from './webaccess/list/webaccess-list.component';
import WebaccessEditComponent from './webaccess/edit/webaccess-edit.component';
import WebaccessShowComponent from './webaccess/show/webaccess-show.component';
import WebaccessService from '../components/webaccess/webaccess.service';
import WebaccessResetPasswordComponent from '../components/webaccess-reset-password/webaccess-reset-password.component';
import WebaccessPickerComponent from '../components/webaccess-picker/webaccess-picker.component';

import LDAPDBComponent from './admin/ldap-db/ldap-db.component';

import QuickbooksImportComponent from './import/quickbooks/quickbooks-import.component';
import QuickbooksListComponent from './import/quickbooks-list/quickbooks-list.component';
import QuickbooksOverviewComponent from './import/quickbooks-overview/quickbooks-overview.component';
import QuickbooksImportService from '../components/quickbooks-import/quickbooks-import.service';

import SendAttachmentEmailComponent from '../components/send-attachment-email/send-attachment-email.component';

import htmlIFrameDirective from '../components/html-iframe/html-iframe.directive';
import iFramePreviewComponent from '../components/iframe-preview/iframe-preview.component';

import StripeService from '../components/stripe/stripe.service';
import ConnectedAccountDetailsComponent from '../components/connected-account-details/connected-account-details.component';
import ConnectedAccountChargesComponent from '../components/connected-account-charges/connected-account-charges.component';

import AdminUserListComponent from './admin/user-list';

import SchemaFormModalComponent from '../components/schema-form-modal/schema-form-modal.component';

import InplaceEditHoverDirective from '../components/inplace-edit-hover/inplace-edit-hover.directive';

import 'angulartics';
import 'angulartics-piwik';

import '../components/picklist-directive/picklist.directive';
import 'angular-translate/dist/angular-translate.min';

import 'chartjs-plugin-stacked100';

import DBAdminService from '../components/db-admin/db-admin.service';
import DBAdminListComponent from './admin/db/list/db-admin-list.component';
import DBAdminEditComponent from './admin/db/edit/db-admin-edit.component';

import ReportFilterModalComponent from '../components/report-filter-modal/report-filter-modal.component';
import SingleAddressLabelModalComponent from '../components/single-address-label-modal/single-address-label-modal.component';

import CustomEntityView from './custom/view/custom-view.component';
import CustomViewService from '../components/custom-view/custom-view.service';

import DTSateService from '../components/datatables-state/datatables-state.service';

import CombinedDateTimePicker from '../components/combined-date-time-picker/combined-date-time-picker.component';

import LetterAddressSelectModalComponent from '../components/letter-address-select-modal/letter-address-select-modal.component';
import LetterAddressDownloadModalComponent from '../components/letter-address-download-modal/letter-address-download-modal.component';

import VoterGroupListComponent from './portfolio/voter-group-list/voter-group-list.component';
import VoterGroupEditComponent from './portfolio/voter-group-edit/voter-group-edit.component';
import VoterGroupShowComponent from './portfolio/voter-group-show/voter-group-show.component';
import VoterGroupsService from '../components/voter-groups/voter-groups.service';

import CustomEntityLookupComponent from "../components/custom-entity-lookup/custom-entity-lookup.component";

import PaymentsOverviewComponent from './payments/overview/payments-overview.component';

import PhotoCardComponent from '../components/photo-card/photo-card.component';

import CustomEntityEditorComponent from './admin/custom-entity-edit/custom-entity-edit.component';

import eforms from './e-form';
import SignatureModal from '../components/signature-modal/signature-modal.component';
import 'angular-signature/src/signature';

import EFormResultModal from  '../components/eform-result-modal/eform-result-modal.component';

import MailComposerComponent from '../app/messaging/mail/composer/mail-composer.component';
import MailListComponent from '../app/messaging/mail/list/mail-list.component';
import MailComposerPreviewComponent from "../components/mail-composer-preview/mail-composer-preview.component";
import MailComposerFilterSendComponent from "../components/mail-composer-filter-send/mail-composer-filter-send.component";

import MailsService from '../components/mails/mails.service';

import DatatableViewComponent from "../components/datatable-view/datatable-view.component";

import TextMessageListComponent from '../app/messaging/text/list/text-list.component';
import TextMessageEditComponent from '../components/text-message-edit/text-message-edit.component';
import TextMessagesService from '../components/text-messages/text-messages.service';
import TextMessageFilterSendComponent from "../components/text-message-filter-send/text-message-filter-send.component";

import phoneNumberEditModalComponent from "../components/phone-number-edit-modal/phone-number-edit-modal.component";

var $stateProviderRef = null;

angular.module('conduu', [ngCookies, ngResource, 'btford.socket-io', uiRouter, permission, uiPermission, 'xeditable','checklist-model',
  uiBootstrap, _Auth, account, navbar, footer, main, constants, socket, util, ngValidationMatch,
  mongooseError, ngDialogs, ngFileUpload, datatables,
  newlineToHtmlFilter, StorageService, 'textAngular', 'angularMoment', HomeComponent, SettingsService,
  SettingsListComponent, SettingsEditComponent, 'ui.codemirror', jsonViewDirective, jsonView,
  FeedbackFormularComponent, startFromFilter, 'angular-timeline', HistoryService, 'chart.js',
  SearchResultComponent,'cgPrompt', ProfileComponent,
  ProfilePictureUploadComponent, ViolationsCodeListComponent, ViolationsCodeEditComponent,
  ViolationCodesService, ViolationTicketListComponent, ViolationTicketEditComponent, ViolationTicketShowComponent,
  ViolationTicketsService, CommunityService, PropertyService, ContactService, 'schemaForm', 'mgcrea.ngStrap',
  CommunityListComponent, CommunityEditComponent, ContactListComponent, ContactEditComponent,ContactShowComponent, PropertyListComponent,
  PropertyEditComponent, VendorListComponent, VendorEditComponent, VendorService, WorkOrderCodeListComponent,
  WorkOrderCodeEditComponent, WorkOrderService, WorkOrderTicketListComponent, WorkOrderTicketEditComponent,
  WorkOrderTicketsService, datetimepicker, ClientSettingsComponent, AcctstComponent, AccountingService,
  JournalEntriesComponent, ChartOfAccountsComponent, BalanceSheetComponent, AddJournalEntryComponent,
  AccountLookupComponent, PropertyLookupComponent, 'treeControl', AccountTreeComponent, VendorLookupComponent,
  'ui.mask', ViewSelectionService, UserLookupComponent, CommunityLookupComponent, TemplateService, TemplateListComponent,
  TemplateEditComponent, TemplateLookupComponent, TaskService, TaskEditComponent, 'cgPrompt', PropertyShowComponent,
  NTASectionComponent, CommunityShowComponent, VendorShowComponent, WorkOrderTicketShowComponent, TaskShowComponent,
  calendar, 'ui.calendar', AddressEditComponent, HeaderDropdownMenuComponent, UserCardComponent, ContactLookupComponent,
  AssetUploadComponent, AttachmentListComponent, ServiceRequestTicketListComponent, ServiceRequestTicketEditComponent,
  ServiceRequestTicketShowComponent, ServiceRequestTicketsService, EditPropertyContactsComponent, AddPropertyContactComponent,
  USPhoneFilter, WorkOrderShowComponent, ViolationShowComponent, StateChangeFormComponent, RoleEditComponent,
  PermissionEditComponent, 'as.sortable', InlineDropdownMenuComponent, ProjectListComponent, ProjectEditComponent,
  ProjectBoardComponent, ProjectService, ProjectItemService, ProjectItemEditComponent, 'ngStorage', RecentVisitsService,
  PinnedItemsService, 'ui.toggle', 'ui.dashboard', DashboardComponent, RolesConfigService, ServiceRequestToWorkOrderComponent,
  TargetDateChangeComponent, IssuedToChangeComponent, ReportsComponent, 'ngIdle', 'stBlurredDialog', CustomEntityList,
  CustomEntityEdit, CustomEntityService, CustomEntityShow, bindDynamicPage, 'ngTagsInput', WebaccessService, WebaccessListComponent,
  WebaccessEditComponent, WebaccessShowComponent, LDAPDBComponent, WebaccessResetPasswordComponent, DataTableLoadingPlaceholderComponent,
  QuickbooksImportComponent, QuickbooksImportService, QuickbooksListComponent, SendAttachmentEmailComponent, WebaccessPickerComponent,
  htmlIFrameDirective, iFramePreviewComponent, StripeService, ConnectedAccountDetailsComponent, ConnectedAccountChargesComponent,
  AdminUserListComponent, SchemaFormModalComponent, InplaceEditHoverDirective, 'angulartics', 'angulartics.piwik', 'fxpicklist',
  'schemaForm-currency', 'schemaForm-picklist', 'pascalprecht.translate', 'dialogs.default-translations', QuickbooksOverviewComponent,
  DBAdminService, DBAdminListComponent, DBAdminEditComponent, ReportFilterModalComponent, SingleAddressLabelModalComponent,
  CustomViewService, CustomEntityView, DTSateService, TemplateUploadComponent, /*'schemaForm-dtpicker',
  CombinedDateTimePicker*/ LetterAddressSelectModalComponent, LetterAddressDownloadModalComponent, VoterGroupListComponent,
  VoterGroupEditComponent, VoterGroupShowComponent, VoterGroupsService, CustomEntityLookupComponent, 'schemaForm-percent',
  PaymentsOverviewComponent, PhotoCardComponent, CustomEntityEditorComponent, eforms, SignatureModal, "signature", EFormResultModal,
  MailComposerComponent, MailListComponent, MailComposerPreviewComponent, MailsService, MailComposerFilterSendComponent, DatatableViewComponent,
  TextMessageListComponent, TextMessageEditComponent, TextMessagesService, TextMessageFilterSendComponent, phoneNumberEditModalComponent
])
  .config(routeConfig)
  .config(schemaFormCustomFields)
  .config(schemaFormSingleFileUpload)
  .config(decorateTextAngular)
  .config(['$provide', function ($provide){
    'ngInject';

    /* Hack to bring UI Bootstrap's Accordeon and UI Sortable together
     * https://stackoverflow.com/questions/26520131/how-can-i-create-a-sortable-accordion-with-angularjs */
    $provide.decorator('uibAccordionDirective', function($delegate) {
      var directive = $delegate[0];
      directive.replace = true;
      return $delegate;
    });
  }])
  .config(['$compileProvider',
    function($compileProvider) {
      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|conduu):/);
    }
  ])
  .config(function($stateProvider) {
    'ngInject';
    $stateProviderRef = $stateProvider;
  })
  .config(function (ChartJsProvider) {
    'ngInject';
    ChartJsProvider.setOptions("global", { colors : [
      '#97BBCD', // blue
      '#B452CD', // medium orchid
      '#F7464A', // red
      '#46BFBD', // green
      '#FDB45C', // yellow
      '#949FB1', // grey
      '#4D5360'  // dark grey
    ] });
  })
  .config(function(KeepaliveProvider, IdleProvider) {
    'ngInject';

    IdleProvider.idle(60*10);
    IdleProvider.timeout(30);
    KeepaliveProvider.interval(10);
  })
  .run(addCustomFieldsCache)
  .run(addSingleFileUploadCache)
  .run(function($rootScope, Idle, stBlurredDialog, $localStorage, Auth) {
    'ngInject';

    $rootScope.events = [];

    $rootScope.$on('IdleStart', function() {
      console.log('%%%%%%%% IdleStart');
      // the user appears to have gone idle
    });

    $rootScope.$on('IdleWarn', function(e, countdown) {
      console.log('%%%%%%%% IdleWarn ' + countdown);
      // follows after the IdleStart event, but includes a countdown until the user is considered timed out
      // the countdown arg is the number of seconds remaining until then.
      // you can change the title or display a warning dialog from here.
      // you can let them resume their session by calling Idle.watch()
    });

    $rootScope.$on('IdleTimeout', function() {

      $localStorage.screenIsLocked = true;
      stBlurredDialog.open();

      console.log('%%%%%%%% IdleTimeout');
      // the user has timed out (meaning idleDuration + timeout has passed without any activity)
      // this is where you'd log them
    });

    $rootScope.$on('IdleEnd', function() {
      console.log('%%%%%%%% IdleEnd');
      // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
    });

    $rootScope.$on('Keepalive', function() {
      console.log('%%%%%%%% Keepalive');
      stBlurredDialog.close();
      // do something to keep the user's session alive
    });

    Auth.isLoggedIn(loggedIn => {

      if (!loggedIn) {
        $localStorage.screenIsLocked = false;
      }

      if ($localStorage.screenIsLocked) {
        stBlurredDialog.open();
      }
    });
  })
  .run(function($rootScope, $location, Auth, editableOptions, SettingsService, $window) {
    'ngInject';
    // Redirect to main if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/');
        }
      });
    });

    editableOptions.theme = 'bs3';  // xeditable theme = bootstrap 3

    // Piwik Page Id
    SettingsService.getByName({name: 'config.platform'}, settings => {
      let analyticsId = settings.data.piwikSiteId;
      if ($window._paq && analyticsId) {
        $window._paq.push(['setSiteId', analyticsId]);
      }
    });

  })
  .run(function (PermPermissionStore) {
    /*
    PermPermissionStore
      .definePermission('community.create', function (RolesConfig) {
        'ngInject';
        return RolesConfig.can({role:['user']},"community.create");
      });
      */
  })
  .controller('DialogCtrl', function($scope, stBlurredDialog){
    'ngInject';
    // Get the data passed from the controller
    $scope.dialogData = stBlurredDialog.getDialogData();
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['conduu']);
  });



// WEBPACK FOOTER //
// ./client/app/app.js